import { API_TYPES } from "@src/appV2/api/apiTypes";
import { agentProfileSchema } from "@src/appV2/Worker/types";
import { z } from "zod";

export const workerSchema = z.object({
  type: z.literal(API_TYPES.worker),
  id: z.string(),
  attributes: agentProfileSchema,
});

export type Worker = z.infer<typeof workerSchema>;
